import _toConsumableArray from "/data/buildAgent/sid-teamcity-agent-01/work/7ee7b29b3220b2e5/portals/UPGRADE/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties2 from "/data/buildAgent/sid-teamcity-agent-01/work/7ee7b29b3220b2e5/portals/UPGRADE/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/data/buildAgent/sid-teamcity-agent-01/work/7ee7b29b3220b2e5/portals/UPGRADE/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == typeof f && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i.return && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(typeof r + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, catch: function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import React, { useContext, useState, useCallback, useMemo, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactTable, { ReactTableDefaults } from 'react-table';
import _ from 'lodash';
import { LocaleService, TranslatorContext, sortWithLocale } from '@jutro/locale';
import { intlMessageShape } from '@jutro/prop-types';
import { useBreakpoint } from '@jutro/layout';
import cx from 'classnames';
import { TransitionGroup } from 'react-transition-group';
import { Chevron, AnimationGroup, getKeyPressHandler, RadioButton, CheckboxField } from '@jutro/components';
import { logDeprecationMessage, uniqueInnerId } from '@jutro/platform';
import { error, warning } from '@jutro/logger';
import { Pagination } from './Pagination/Pagination';
import { SHOW_ALL_PAGES } from './Pagination/PageSizes';
import { TableBar } from './TableBar';
import { defaultColumnFilter } from './helper';
import { useExpansion } from './state/expansion/useExpansion';
import { useSelection } from './state/selection/useSelection';
import { useConfig } from './state/config/useConfig';
import { useAsync } from './state/async/useAsync';
import { useAccessibilityProps } from './accessibility/useAccessibilityProps';
import { TableContext } from './TableContext';
import { RadioColumn } from './columns/RadioColumn';
import { ActionColumn } from './columns/ActionColumn';
import { messages } from './DataTable.messages';
import styles from "./DataTable.module.css";
import 'react-table/react-table.css';
var nonConfigurableColumns = [RadioColumn, ActionColumn];
var textAlignMapping = {
  left: styles.textLeft,
  right: styles.textRight
};
var expanderDefaults = _objectSpread({}, ReactTableDefaults.expanderDefaults, {
  width: 28
});
var AnimatedTrGroupComponent = function AnimatedTrGroupComponent(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties2(_ref, ["children"]);
  return React.createElement(ReactTableDefaults.TrGroupComponent, props, React.createElement(TransitionGroup, {
    component: null
  }, children));
};
var transitionGroupProps = ['onExited', 'in', 'appear', 'enter', 'exit'];
var AnimationResistantTrComponent = function AnimationResistantTrComponent(_ref2) {
  var hasActions = _ref2.hasActions,
    props = _objectWithoutProperties2(_ref2, ["hasActions"]);
  var a11yProps = {};
  if (hasActions) {
    a11yProps.tabIndex = 0;
    a11yProps.role = 'button';
    a11yProps['aria-label'] = 'row';
  }
  return React.createElement(ReactTableDefaults.TrComponent, _extends({}, a11yProps, _.omit(props, transitionGroupProps)));
};
var splitHeaderText = function splitHeaderText(text) {
  return React.createElement("span", {
    className: styles.headerMultiline
  }, text);
};
var renderNull = function renderNull() {
  return null;
};
var ignoredClickTargets = ['INPUT', 'BUTTON', 'A', 'LABEL', 'SELECT', 'I'];
var handleNestedClick = function handleNestedClick(event, callback) {
  var currentTarget = event.target;
  if (currentTarget && _includesInstanceProperty(ignoredClickTargets).call(ignoredClickTargets, currentTarget.tagName)) {
    return;
  }
  callback(event);
};
var isEnabledColumn = function isEnabledColumn() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$enabled;
  return (_config$enabled = config.enabled) !== null && _config$enabled !== void 0 ? _config$enabled : true;
};
var findById = function findById(id) {
  return function (_ref3) {
    var configId = _ref3.id;
    return id === configId;
  };
};
var orderColumnsUsingConfig = function orderColumnsUsingConfig(config) {
  return function (columnA, columnB) {
    var aInitialIndex = _findIndexInstanceProperty(config).call(config, findById(columnA.props.id));
    var bInitialIndex = _findIndexInstanceProperty(config).call(config, findById(columnB.props.id));
    if (aInitialIndex === -1 || bInitialIndex === -1) {
      return 0;
    }
    return aInitialIndex - bInitialIndex;
  };
};
var getAsyncParams = function getAsyncParams(params) {
  return _.pick(params, ['page', 'pageSize', 'sorted', 'filterValue']);
};
var dataTableConfigColumnsShape = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired
}));
var dataTableConfigColumnsSortedShape = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string.isRequired,
  desc: PropTypes.bool.isRequired
}));
var dataTableConfigShape = PropTypes.shape({
  editedRow: PropTypes.number,
  columns: dataTableConfigColumnsShape,
  filterValue: PropTypes.string,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  sorted: dataTableConfigColumnsSortedShape
});
var rowIdShape = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
var dataTablePropTypes = {
  id: PropTypes.string.isRequired,
  showSearch: PropTypes.bool,
  showPagination: PropTypes.bool,
  config: dataTableConfigShape,
  defaultConfig: dataTableConfigShape,
  onConfigChange: PropTypes.func,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  data: PropTypes.arrayOf(PropTypes.object),
  onFilter: PropTypes.func,
  onColumnFilter: PropTypes.func,
  filterPlaceholder: intlMessageShape,
  children: PropTypes.node.isRequired,
  expandable: PropTypes.bool,
  multipleRowsExpandable: PropTypes.bool,
  renderExpanderContent: PropTypes.func,
  headerMultiline: PropTypes.bool,
  onRowClick: PropTypes.func,
  expandOnRowClick: PropTypes.bool,
  selectOnRowClick: PropTypes.bool,
  selectionType: PropTypes.oneOf(['none', 'single', 'multi']),
  selectedRows: PropTypes.arrayOf(rowIdShape),
  selectionActions: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    callback: PropTypes.func.isRequired
  })),
  onSelectionChange: PropTypes.func,
  columnsConfigurable: PropTypes.bool,
  loadingText: intlMessageShape,
  noDataText: intlMessageShape,
  localSorting: PropTypes.bool,
  phone: PropTypes.object,
  phoneWide: PropTypes.object,
  tablet: PropTypes.object,
  onSaveRow: PropTypes.func,
  onEditCancel: PropTypes.func,
  onEditStart: PropTypes.func,
  path: PropTypes.string,
  onFetchData: PropTypes.func,
  onGetRowId: PropTypes.func,
  rowIdPath: PropTypes.string,
  tableLabel: intlMessageShape,
  numberOfRows: PropTypes.number
};
export var DataTable = function DataTable(dataTableProps) {
  var _useBreakpoint = useBreakpoint(dataTableProps),
    breakpointProps = _useBreakpoint.breakpointProps,
    applyBreakpoint = _useBreakpoint.applyBreakpoint,
    breakpoint = _useBreakpoint.breakpoint;
  var id = breakpointProps.id,
    showSearch = breakpointProps.showSearch,
    showPagination = breakpointProps.showPagination,
    pageSizeOptions = breakpointProps.pageSizeOptions,
    syncData = breakpointProps.data,
    onFilter = breakpointProps.onFilter,
    onColumnFilter = breakpointProps.onColumnFilter,
    defaultConfig = breakpointProps.defaultConfig,
    config = breakpointProps.config,
    filterPlaceholder = breakpointProps.filterPlaceholder,
    children = breakpointProps.children,
    onConfigChange = breakpointProps.onConfigChange,
    onSaveRow = breakpointProps.onSaveRow,
    onEditCancel = breakpointProps.onEditCancel,
    onEditStart = breakpointProps.onEditStart,
    expandable = breakpointProps.expandable,
    multipleRowsExpandable = breakpointProps.multipleRowsExpandable,
    renderExpanderContent = breakpointProps.renderExpanderContent,
    basePath = breakpointProps.path,
    headerMultiline = breakpointProps.headerMultiline,
    onRowClick = breakpointProps.onRowClick,
    expandOnRowClick = breakpointProps.expandOnRowClick,
    selectOnRowClick = breakpointProps.selectOnRowClick,
    selectionType = breakpointProps.selectionType,
    onGetRowIdProp = breakpointProps.onGetRowId,
    rowIdPath = breakpointProps.rowIdPath,
    selectedRows = breakpointProps.selectedRows,
    selectionActions = breakpointProps.selectionActions,
    onSelectionChange = breakpointProps.onSelectionChange,
    onFetchData = breakpointProps.onFetchData,
    columnsConfigurable = breakpointProps.columnsConfigurable,
    loadingText = breakpointProps.loadingText,
    noDataText = breakpointProps.noDataText,
    localSorting = breakpointProps.localSorting,
    tableLabel = breakpointProps.tableLabel,
    numberOfRowsProp = breakpointProps.numberOfRows;
  var onGetRowId = useMemo(function () {
    return rowIdPath ? function (row) {
      return row[rowIdPath];
    } : onGetRowIdProp;
  }, [onGetRowIdProp, rowIdPath]);
  var childrenArray = React.Children.toArray(children);
  var reactTable = useRef();
  var shouldShowSearch = showSearch !== false;
  var shouldShowPagination = showPagination !== false;
  var shouldBeExpandable = expandable && !!renderExpanderContent;
  var shouldBeSelectable = selectionType !== 'none';
  var translator = useContext(TranslatorContext);
  var language = LocaleService.getStoredLanguage();
  var _useExpansion = useExpansion(),
    _useExpansion2 = _slicedToArray(_useExpansion, 2),
    expandedRows = _useExpansion2[0],
    _useExpansion2$ = _useExpansion2[1],
    collapse = _useExpansion2$.collapse,
    toggleExpansion = _useExpansion2$.toggle,
    collapseAll = _useExpansion2$.collapseAll;
  var _useSelection = useSelection({
      all: false,
      rows: selectedRows || []
    }, selectedRows, selectionType, onSelectionChange),
    _useSelection2 = _slicedToArray(_useSelection, 2),
    selectedState = _useSelection2[0],
    _useSelection2$ = _useSelection2[1],
    selectRow = _useSelection2$.select,
    toggleSelection = _useSelection2$.toggle,
    setAll = _useSelection2$.setAll,
    clearAll = _useSelection2$.clearAll;
  var _useAsync = useAsync(),
    _useAsync2 = _slicedToArray(_useAsync, 2),
    _useAsync2$ = _useAsync2[0],
    asyncData = _useAsync2$.asyncData,
    loading = _useAsync2$.loading,
    totalNumberOfRows = _useAsync2$.numberOfRows,
    asyncActions = _useAsync2[1];
  var data = onFetchData ? asyncData : syncData;
  var getEditProps = function getEditProps(rowId) {
    return rowId !== undefined ? {
      rowId: rowId,
      row: _findInstanceProperty(data).call(data, function (row, index) {
        return onGetRowId(row, index) === rowId;
      })
    } : {};
  };
  var _useState = useState(getEditProps((config === null || config === void 0 ? void 0 : config.editedRow) || defaultConfig.editedRow)),
    _useState2 = _slicedToArray(_useState, 2),
    editProps = _useState2[0],
    setEditProps = _useState2[1];
  var updateEditedRow = function updateEditedRow(rowId) {
    return setEditProps(getEditProps(rowId));
  };
  var initialColumnsConfig = useMemo(function () {
    var _config$columns, _context;
    var initialConfig = (_config$columns = config === null || config === void 0 ? void 0 : config.columns) !== null && _config$columns !== void 0 ? _config$columns : defaultConfig.columns;
    var withInitialConfig = initialConfig === null || initialConfig === void 0 ? void 0 : initialConfig.length;
    if (!childrenArray.length) {
      return [];
    }
    if (withInitialConfig) {
      _sortInstanceProperty(childrenArray).call(childrenArray, orderColumnsUsingConfig(initialConfig));
    }
    return _filterInstanceProperty(_context = _mapInstanceProperty(childrenArray).call(childrenArray, function (childColumn) {
      var columnChildId = childColumn.props.id,
        type = childColumn.type;
      if (_includesInstanceProperty(nonConfigurableColumns).call(nonConfigurableColumns, type)) {
        return undefined;
      }
      var columnConfig = {
        id: columnChildId,
        enabled: true
      };
      if (withInitialConfig) {
        var initialColumnConfig = _findInstanceProperty(initialConfig).call(initialConfig, function (_ref4) {
          var configId = _ref4.id;
          return columnChildId === configId;
        });
        columnConfig.enabled = isEnabledColumn(initialColumnConfig);
      }
      return columnConfig;
    })).call(_context, Boolean);
  }, [childrenArray, config, defaultConfig]);
  var _useConfig = useConfig(_objectSpread({}, defaultConfig, {
      columns: initialColumnsConfig
    }), config && function () {
      if (config.editedRow !== (editProps === null || editProps === void 0 ? void 0 : editProps.rowId)) {
        updateEditedRow(config.editedRow);
      }
      return _objectSpread({}, config, {
        columns: initialColumnsConfig
      });
    }, onConfigChange),
    _useConfig2 = _slicedToArray(_useConfig, 2),
    _useConfig2$ = _useConfig2[0],
    filterValue = _useConfig2$.filterValue,
    pageSizeSelectedOption = _useConfig2$.pageSize,
    page = _useConfig2$.page,
    sorted = _useConfig2$.sorted,
    columns = _useConfig2$.columns,
    editedRow = _useConfig2$.editedRow,
    _useConfig2$2 = _useConfig2[1],
    setFilterValue = _useConfig2$2.setFilterValue,
    setPageSize = _useConfig2$2.setPageSize,
    setPage = _useConfig2$2.setPage,
    setSorted = _useConfig2$2.setSorted,
    setColumns = _useConfig2$2.setColumns,
    setEditedRow = _useConfig2$2.setEditedRow;
  var _useAccessibilityProp = useAccessibilityProps({
      selectionType: selectionType,
      isExpandable: expandable && renderExpanderContent,
      tableId: id,
      sorted: sorted,
      tableLabel: translator(tableLabel)
    }),
    getA11yTrGroupProps = _useAccessibilityProp.getA11yTrGroupProps,
    getA11yTrProps = _useAccessibilityProp.getA11yTrProps,
    getA11yTableProps = _useAccessibilityProp.getA11yTableProps,
    getA11yTheadThPropsHeader = _useAccessibilityProp.getA11yTheadThPropsHeader,
    getA11yTheadThPropsSortableHeader = _useAccessibilityProp.getA11yTheadThPropsSortableHeader,
    getA11yTdProps = _useAccessibilityProp.getA11yTdProps;
  var isEdited = useCallback(function (rowId) {
    return editedRow === rowId;
  }, [editedRow]);
  var editActions = {
    start: function start(row, index) {
      var rowId = onGetRowId(row, index);
      if (onEditStart) {
        onEditStart(row, rowId);
      }
      setEditedRow(rowId);
      updateEditedRow(rowId);
      collapse(rowId);
    },
    update: function update(_row, path, newValue) {
      setEditProps(function (oldEditProps) {
        return _objectSpread({}, oldEditProps, {
          row: _objectSpread({}, oldEditProps.row, _defineProperty({}, path, newValue))
        });
      });
    },
    cancel: function cancel() {
      if (onEditCancel) {
        onEditCancel(editProps.row, editProps.rowId);
      }
      setEditedRow();
      updateEditedRow();
    },
    save: function save() {
      if (onSaveRow) {
        onSaveRow(editProps.row, editProps.rowId);
      }
      setEditedRow();
      updateEditedRow();
    }
  };
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    pressedRowId = _useState4[0],
    setPressedRowId = _useState4[1];
  var handleExpand = useCallback(function (rowId, viewIndex) {
    return !isEdited(rowId) && toggleExpansion(rowId, viewIndex, multipleRowsExpandable);
  }, [isEdited, multipleRowsExpandable, toggleExpansion]);
  var filterFunction = useMemo(function () {
    if (onFilter) {
      return onFilter;
    }
    return function (value) {
      var valueFilters = _mapInstanceProperty(childrenArray).call(childrenArray, function (_ref5) {
        var props = _ref5.props;
        return (props.onFilter || onColumnFilter)(value, props);
      });
      return function (item, index, tableData) {
        return _someInstanceProperty(valueFilters).call(valueFilters, function (valueFilter) {
          return valueFilter(item, index, tableData);
        });
      };
    };
  }, [onFilter, childrenArray, onColumnFilter]);
  var contextColumnsConfig = useMemo(function () {
    return _mapInstanceProperty(columns).call(columns, function (columnConfig) {
      var childColumn = _findInstanceProperty(childrenArray).call(childrenArray, function (_ref6) {
        var columnChildId = _ref6.props.id;
        return columnConfig.id === columnChildId;
      });
      return _objectSpread({}, columnConfig, {
        header: childColumn.props.header
      });
    });
  }, [childrenArray, columns]);
  var tableContext = useMemo(function () {
    return {
      styles: styles,
      columns: _objectSpread({
        configurable: columnsConfigurable,
        config: contextColumnsConfig
      }, columnsConfigurable && {
        setConfig: setColumns
      })
    };
  }, [columnsConfigurable, contextColumnsConfig, setColumns]);
  var filteredData = useMemo(function () {
    if (!data || !children) return [];
    return shouldShowSearch && filterValue ? _filterInstanceProperty(data).call(data, filterFunction(filterValue)) : data;
  }, [shouldShowSearch, data, children, filterFunction, filterValue]);
  var numberOfRows = onFetchData ? totalNumberOfRows : numberOfRowsProp || filteredData.length;
  var pageSize = useMemo(function () {
    return !shouldShowPagination || pageSizeSelectedOption === SHOW_ALL_PAGES ? numberOfRows : pageSizeSelectedOption;
  }, [shouldShowPagination, pageSizeSelectedOption, numberOfRows]);
  var Expander = useCallback(function (_ref7) {
    var isExpanded = _ref7.isExpanded,
      row = _ref7.row,
      index = _ref7.index,
      viewIndex = _ref7.viewIndex;
    return React.createElement(Chevron, {
      isOpen: isExpanded,
      className: styles.expanderIcon,
      tabIndex: "0",
      role: "button",
      messageProps: {
        label: !isExpanded ? messages.collapsedRowLabel : messages.expandedRowLabel
      },
      onMouseDown: function onMouseDown(event) {
        event.preventDefault();
      },
      onKeyPress: getKeyPressHandler(function () {
        return toggleExpansion(onGetRowId(row, index), viewIndex, multipleRowsExpandable);
      })
    });
  }, [toggleExpansion, multipleRowsExpandable, onGetRowId]);
  var getExpandRowActions = useCallback(function (_ref8) {
    var index = _ref8.index,
      viewIndex = _ref8.viewIndex,
      row = _ref8.row;
    return shouldBeExpandable && expandOnRowClick && function () {
      return handleExpand(onGetRowId(row, index), viewIndex);
    };
  }, [expandOnRowClick, handleExpand, shouldBeExpandable, onGetRowId]);
  var SelectionHeader = useMemo(function () {
    if (selectionType !== 'multi') {
      return undefined;
    }
    return function () {
      return React.createElement(CheckboxField, {
        id: "".concat(id, "-select-all"),
        onValueChange: function onValueChange(value) {
          if (value) {
            var _context2;
            var allRows = reactTable.current.getResolvedState().sortedData;
            var startIndex = page * pageSize;
            var visibleRows = _mapInstanceProperty(_context2 = _sliceInstanceProperty(allRows).call(allRows, startIndex, startIndex + pageSize)).call(_context2, function (_ref9) {
              var _original = _ref9._original,
                _index = _ref9._index;
              return onGetRowId(_original, _index);
            });
            setAll(visibleRows);
          } else {
            clearAll();
          }
        },
        value: selectedState.all
      });
    };
  }, [id, pageSize, page, selectionType, selectedState.all, clearAll, setAll, onGetRowId]);
  var SelectionCell = useMemo(function () {
    if (selectionType === 'none') {
      return undefined;
    }
    if (selectionType === 'single') {
      return function (_ref0) {
        var index = _ref0.index,
          viewIndex = _ref0.viewIndex,
          row = _ref0.original;
        var rowId = onGetRowId(row, index);
        return React.createElement(RadioButton, {
          id: "".concat(id, "-select-").concat(viewIndex),
          option: {
            code: rowId
          },
          onValueChange: function onValueChange() {
            return selectRow(rowId);
          },
          value: "".concat(selectedState.rows[0]),
          className: styles.radio,
          tabIndex: "0"
        });
      };
    }
    return function (_ref1) {
      var index = _ref1.index,
        viewIndex = _ref1.viewIndex,
        row = _ref1.original;
      var _context3;
      var rowId = onGetRowId(row, index);
      return React.createElement(CheckboxField, {
        id: "".concat(id, "-select-").concat(viewIndex),
        onValueChange: function onValueChange() {
          return toggleSelection(rowId);
        },
        value: _includesInstanceProperty(_context3 = selectedState.rows).call(_context3, rowId)
      });
    };
  }, [id, selectionType, selectedState.rows, selectRow, toggleSelection, onGetRowId]);
  var shouldDisableActions = selectedState.rows.length > 1;
  var columnsArray = useMemo(function () {
    var _context5;
    var visibleColumns = childrenArray;
    if (columns !== null && columns !== void 0 && columns.length) {
      var _context4;
      visibleColumns = _sortInstanceProperty(_context4 = _filterInstanceProperty(visibleColumns).call(visibleColumns, function (_ref10) {
        var colId = _ref10.props.id;
        var _columnConfig$enabled;
        var columnConfig = _findInstanceProperty(columns).call(columns, function (_ref11) {
          var configId = _ref11.id;
          return colId === configId;
        });
        return (_columnConfig$enabled = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.enabled) !== null && _columnConfig$enabled !== void 0 ? _columnConfig$enabled : true;
      })).call(_context4, orderColumnsUsingConfig(columns));
    }
    var childrenColumns = _mapInstanceProperty(visibleColumns).call(visibleColumns, function (_ref12, columnIndex) {
      var props = _ref12.props,
        type = _ref12.type;
      var _applyBreakpoint = applyBreakpoint(props),
        cell = _applyBreakpoint.cell,
        renderCell = _applyBreakpoint.renderCell,
        renderEditCell = _applyBreakpoint.renderEditCell,
        getRowActions = _applyBreakpoint.getRowActions,
        columnClassName = _applyBreakpoint.columnClassName,
        rest = _objectWithoutProperties(_applyBreakpoint, ["cell", "renderCell", "renderEditCell", "getRowActions", "columnClassName"]);
      var childId = rest.id,
        header = rest.header,
        renderHeader = rest.renderHeader,
        textAlign = rest.textAlign,
        visible = rest.visible,
        headerClassName = rest.headerClassName,
        cellClassName = rest.cellClassName,
        columnProportion = rest.columnProportion,
        width = rest.width,
        sortable = rest.sortable,
        readOnly = rest.readOnly,
        editCellClass = rest.editCellClass,
        path = rest.path,
        onSort = rest.onSort,
        onAccessor = rest.onAccessor;
      if ((type === null || type === void 0 ? void 0 : type.name) === 'MoneyColumn') {
        logDeprecationMessage('MoneyColumn', 'DisplayColumn with [fieldDatatype="currency"]', undefined, '6.0.0');
      }
      var cellCallback = cell || renderCell;
      var editCellCallback = renderEditCell;
      var propsToCallback = _objectSpread({}, rest, {
        basePath: basePath,
        translator: translator,
        disableActions: shouldDisableActions,
        breakpoint: breakpoint
      });
      var Cell = cellCallback && function (_ref13) {
        var original = _ref13.original,
          index = _ref13.index;
        var rowId = onGetRowId(original, index);
        if (!readOnly && editCellCallback && isEdited(rowId)) {
          return editCellCallback({
            props: propsToCallback,
            editProps: _objectSpread({}, editProps, {
              index: index
            }),
            editActions: editActions
          });
        }
        return cellCallback(original, rowId, propsToCallback, editActions.start);
      };
      var headerText = translator(header);
      var headerFunction = renderHeader || (headerMultiline ? splitHeaderText : _.identity);
      var columnType = (type === null || type === void 0 ? void 0 : type.name) === 'ActionColumn' ? 'actions' : 'display';
      return {
        id: childId || columnIndex,
        type: columnType,
        Header: function Header() {
          return headerFunction(headerText);
        },
        Cell: Cell,
        className: cx(textAlignMapping[textAlign], columnClassName, cellClassName),
        headerClassName: cx(textAlignMapping[textAlign], _defineProperty({}, styles.headerOneLine, !headerMultiline), headerClassName),
        show: visible === undefined ? true : visible,
        minWidth: columnProportion,
        width: width,
        sortable: sortable,
        readOnly: readOnly,
        editCellClass: editCellClass,
        textAlign: textAlign,
        accessor: onAccessor || path,
        header: headerText,
        getRowActions: getRowActions,
        props: rest,
        sortMethod: onSort
      };
    });
    var selectionClassName = cx(styles.selectionCell, _defineProperty({}, styles.serviceCell, shouldBeExpandable));
    var selectionWidth = 44;
    var expanderClassName = cx(styles.expanderCell, _defineProperty({}, styles.serviceCell, shouldBeSelectable));
    var expanderWidth = 28;
    var serviceColumns = _filterInstanceProperty(_context5 = [shouldBeSelectable && {
      id: 'selection',
      type: "".concat(selectionType, "_selection"),
      Header: SelectionHeader,
      Cell: SelectionCell,
      sortable: false,
      resizable: false,
      minWidth: selectionWidth,
      width: selectionWidth,
      textAlign: 'center',
      headerClassName: selectionClassName,
      className: selectionClassName
    }, shouldBeExpandable && {
      id: 'expander',
      type: 'expander',
      expander: true,
      readOnly: true,
      getRowActions: getExpandRowActions,
      Expander: Expander,
      className: expanderClassName,
      isEdited: isEdited,
      width: expanderWidth,
      minWidth: expanderWidth
    }]).call(_context5, Boolean);
    return _concatInstanceProperty(serviceColumns).call(serviceColumns, childrenColumns);
  }, [childrenArray, columns, shouldBeExpandable, shouldBeSelectable, SelectionHeader, SelectionCell, getExpandRowActions, Expander, isEdited, applyBreakpoint, basePath, shouldDisableActions, breakpoint, translator, headerMultiline, editActions, editProps, onGetRowId]);
  var getTrProps = useCallback(function (item, row) {
    var _context6, _context7;
    var rowColumns = item.columns;
    var original = row.original,
      index = row.index,
      viewIndex = row.viewIndex;
    var rowClickAction = onRowClick && function (event) {
      return onRowClick(original, index, event);
    };
    var availableActions = _filterInstanceProperty(_context6 = _.flatten([rowClickAction].concat(_toConsumableArray(_mapInstanceProperty(rowColumns).call(rowColumns, function (_ref14) {
      var getRowActions = _ref14.getRowActions,
        props = _ref14.props;
      return getRowActions && getRowActions({
        row: original,
        index: index,
        viewIndex: viewIndex,
        props: props,
        onEditStart: editActions.start,
        selectOnRowClick: selectOnRowClick,
        expandOnRowClick: expandOnRowClick
      });
    }))))).call(_context6, Boolean);
    var rowId = onGetRowId(original, index);
    var hasActions = availableActions.length;
    var isRowPressed = pressedRowId === rowId;
    var isRowSelected = _includesInstanceProperty(_context7 = selectedState.rows).call(_context7, rowId);
    var isRowEdited = isEdited(rowId);
    var actionsHandler = function actionsHandler(event) {
      if (event.target === event.currentTarget) {
        event.preventDefault();
      }
      _forEachInstanceProperty(availableActions).call(availableActions, function (action) {
        return handleNestedClick(event, action);
      });
    };
    var getRowPressHandler = function getRowPressHandler(callback) {
      return function (event) {
        if (event.key !== ' ' && event.key !== 'Enter') {
          return;
        }
        handleNestedClick(event, callback);
      };
    };
    var props = _objectSpread({
      hasActions: hasActions,
      className: cx(styles.tableRow, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles.clickableRow, hasActions), styles.activeRow, isRowPressed), styles.selectedRow, isRowSelected), styles.editedRow, isRowEdited))
    }, getA11yTrProps());
    if (hasActions) {
      props.onClick = actionsHandler;
      props.onKeyPress = getRowPressHandler(actionsHandler);
      props.onKeyDown = getRowPressHandler(function () {
        return pressedRowId !== rowId && setPressedRowId(rowId);
      });
      props.onKeyUp = getRowPressHandler(function () {
        return setPressedRowId(null);
      });
    }
    return props;
  }, [editActions.start, expandOnRowClick, onRowClick, pressedRowId, selectOnRowClick, selectedState.rows, onGetRowId, getA11yTrProps, isEdited]);
  var getTdProps = useCallback(function (state, row, _ref15) {
    var readOnly = _ref15.readOnly,
      textAlign = _ref15.textAlign,
      editCellClass = _ref15.editCellClass,
      type = _ref15.type,
      columnId = _ref15.id;
    var index = row.index,
      viewIndex = row.viewIndex,
      original = row.original;
    var rowId = onGetRowId(original, index);
    var edited = isEdited(rowId);
    var isExpander = type === 'expander';
    var shouldBeFocusable = type !== 'display';
    return _objectSpread({
      className: cx(styles.tableCell, _defineProperty(_defineProperty(_defineProperty({}, editCellClass, editCellClass && !readOnly && edited), styles.rightAlignCell, textAlign === 'right'), "disabled", isExpander && edited)),
      onClick: isExpander && function () {
        return handleExpand(rowId, viewIndex);
      }
    }, getA11yTdProps(state, row, columnId, shouldBeFocusable));
  }, [isEdited, handleExpand, onGetRowId, getA11yTdProps]);
  var getHeaderCellProps = useCallback(function (_props, _columnInfo, column) {
    var sortable = column.sortable === undefined || column.sortable;
    var sharedProps = {
      className: cx(styles.tableHeaderCell, _defineProperty({}, styles.unsortedHeaderCell, !sortable)),
      title: column.header
    };
    if (sortable) {
      return _objectSpread({}, sharedProps, {}, getA11yTheadThPropsSortableHeader(_props, column.id, column.type));
    }
    return _objectSpread({}, sharedProps, {
      pointerEvents: 'none'
    }, getA11yTheadThPropsHeader(_props, column.id, column.type));
  }, [getA11yTheadThPropsSortableHeader, getA11yTheadThPropsHeader]);
  var defaultSortMethod = useCallback(function (a, b) {
    var sortingFunction = sortWithLocale(language);
    return sortingFunction(normalize(a), normalize(b));
  }, [language]);
  var tbodyProps = numberOfRows === 0 && {
    TbodyComponent: function TbodyComponent() {
      return React.createElement("div", {
        className: styles.noDataMessage
      }, translator(noDataText));
    }
  };
  var handleAsyncDataChange = useCallback(function _callee(asyncConfigs) {
    var _reactTable$current, setAsyncData, setLoading, reactTableState, asyncParams, fetchedData;
    return _regeneratorRuntime().async(function _callee$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          setAsyncData = asyncActions.setAsyncData, setLoading = asyncActions.setLoading;
          reactTableState = reactTable === null || reactTable === void 0 ? void 0 : (_reactTable$current = reactTable.current) === null || _reactTable$current === void 0 ? void 0 : _reactTable$current.state;
          asyncParams = _objectSpread({}, getAsyncParams(reactTableState), {}, getAsyncParams(asyncConfigs));
          _context8.prev = 3;
          setLoading(true);
          _context8.next = 7;
          return _regeneratorRuntime().awrap(onFetchData(asyncParams));
        case 7:
          fetchedData = _context8.sent;
          setAsyncData(fetchedData.rows, fetchedData.numberOfRows);
          _context8.next = 14;
          break;
        case 11:
          _context8.prev = 11;
          _context8.t0 = _context8["catch"](3);
          error("Failed to fetch data, ".concat(_context8.t0));
        case 14:
          _context8.prev = 14;
          setLoading(false);
          return _context8.finish(14);
        case 17:
        case "end":
          return _context8.stop();
      }
    }, null, null, [[3, 11, 14, 17]], Promise);
  }, [asyncActions, onFetchData]);
  var debounceFilter = useCallback(_.debounce(function (newFilterValue) {
    handleAsyncDataChange({
      filterValue: newFilterValue,
      page: 0
    });
  }, 500), [handleAsyncDataChange]);
  var modeProps = onFetchData ? {
    data: data,
    loading: loading,
    filterValue: filterValue,
    loadingText: translator(loadingText)
  } : {
    sorted: sorted,
    defaultSortMethod: defaultSortMethod,
    page: page
  };
  var isSortedOnServer = onFetchData && !localSorting;
  var isControlledMode = !onFetchData && numberOfRowsProp !== undefined;
  var handleSortedChange = useCallback(function (newSortedValue) {
    setSorted(newSortedValue, isSortedOnServer || isControlledMode);
    collapseAll();
    if (isSortedOnServer) {
      handleAsyncDataChange({
        sorted: newSortedValue,
        page: 0
      });
    }
  }, [setSorted, isSortedOnServer, collapseAll, handleAsyncDataChange]);
  var handlePageChange = useCallback(function (newPage) {
    setPage(newPage);
    collapseAll();
    if (onFetchData) {
      handleAsyncDataChange({
        page: newPage
      });
    }
  }, [setPage, collapseAll, onFetchData, handleAsyncDataChange]);
  var getPaginationComponent = useCallback(function () {
    var _uniqueInnerId = uniqueInnerId(id, 'paginationId'),
      paginationId = _uniqueInnerId.paginationId;
    var handleSelectPageSizeChange = function handleSelectPageSizeChange(value) {
      var newPageSize = value === SHOW_ALL_PAGES ? value : Number(value);
      setPageSize(newPageSize, true);
      collapseAll();
      if (onFetchData) {
        handleAsyncDataChange({
          page: 0,
          pageSize: newPageSize
        });
      }
    };
    return React.createElement(Pagination, {
      id: "".concat(paginationId, "_pagination"),
      numberOfRows: numberOfRows,
      pageSize: pageSize,
      pageSizeOptions: pageSizeOptions,
      pageSizeSelectedOption: pageSizeSelectedOption,
      onSelectPageSizeChange: handleSelectPageSizeChange,
      page: page,
      onPageChange: handlePageChange,
      canNext: page < Math.ceil(numberOfRows / pageSize) - 1,
      canPrevious: page !== 0
    });
  }, [collapseAll, handleAsyncDataChange, handlePageChange, id, numberOfRows, onFetchData, page, pageSize, pageSizeOptions, pageSizeSelectedOption, setPageSize]);
  var paginationProps = shouldShowPagination && numberOfRows > 0 ? {
    defaultPageSize: defaultConfig.pageSize,
    PaginationComponent: getPaginationComponent
  } : {
    showPagination: false,
    pageSize: numberOfRows
  };
  var expanderContentWrapper = useCallback(function (_ref16) {
    var rowData = _ref16.original;
    var expanderContentWrapperStyles = cx(styles.expandableRowWrapper, styles.expandableRow);
    return React.createElement(AnimationGroup, {
      animation: "expand",
      appear: true,
      in: true
    }, React.createElement("div", {
      className: expanderContentWrapperStyles
    }, renderExpanderContent(rowData)));
  }, [renderExpanderContent]);
  var subComponent = shouldBeExpandable ? expanderContentWrapper : null;
  var renderTableBar = useCallback(function () {
    var handleFilterChange = function handleFilterChange(newFilterValue) {
      setFilterValue(newFilterValue, true);
      if (onFetchData) {
        debounceFilter(newFilterValue);
      }
      collapseAll();
    };
    var actions = selectionActions === null || selectionActions === void 0 ? void 0 : _mapInstanceProperty(selectionActions).call(selectionActions, function (_ref17) {
      var _callback = _ref17.callback,
        rest = _objectWithoutProperties2(_ref17, ["callback"]);
      return _objectSpread({}, rest, {
        callback: function callback() {
          _callback(selectedState.rows);
          clearAll();
        }
      });
    });
    return React.createElement(TableContext.Provider, {
      value: tableContext
    }, React.createElement(TableBar, {
      filterValue: filterValue,
      onFilterChange: handleFilterChange,
      filterPlaceholder: translator(filterPlaceholder),
      selectionActions: actions,
      showSelectionActions: !!selectedState.rows.length,
      disabled: loading
    }));
  }, [debounceFilter, filterPlaceholder, filterValue, clearAll, loading, onFetchData, selectedState.rows, selectionActions, setFilterValue, tableContext, translator, collapseAll]);
  var reactTableKey = "".concat(id, "_").concat(onFetchData ? 'async' : 'sync');
  var getStyleProps = useCallback(function () {
    return _.mapValues({
      getTheadProps: styles.tableHeader,
      getTbodyProps: styles.tableBody,
      getTrGroupProps: styles.tableRowGroup
    }, function (className) {
      return function () {
        return _objectSpread({
          className: className
        }, getA11yTrGroupProps());
      };
    });
  }, [getA11yTrGroupProps]);
  useEffect(function () {
    if (!onFetchData && numberOfRowsProp === undefined) {
      var isFirstPage = page === 0;
      var isLastPage = page === Math.floor(filteredData.length / pageSize);
      var isPageEmpty = isLastPage && filteredData.length % pageSize === 0;
      if (!isFirstPage && isPageEmpty) {
        setPage(page - 1);
      }
    }
  }, [pageSize, page, onFetchData, setPage, filteredData, numberOfRowsProp]);
  useEffect(function () {
    if (onFetchData) {
      if (syncData || numberOfRowsProp) {
        warning('The props `data` and `numberOfRows` will not be used when `onFetchData` prop is provided');
      }
      handleAsyncDataChange(defaultConfig);
    }
  }, [handleAsyncDataChange, onFetchData, syncData, numberOfRowsProp, defaultConfig]);
  return React.createElement("div", {
    id: id,
    className: styles.dataTable
  }, shouldShowSearch && renderTableBar(), React.createElement(ReactTable, _extends({
    key: reactTableKey,
    ref: reactTable,
    data: filteredData,
    columns: columnsArray,
    getTheadThProps: getHeaderCellProps,
    minRows: 0,
    styles: styles,
    className: cx(styles.reactTable, '-striped', '-highlight'),
    SubComponent: subComponent,
    expanded: expandedRows
  }, paginationProps, getStyleProps(), tbodyProps, {
    getTdProps: getTdProps,
    getTrProps: getTrProps,
    getTheadTrProps: getA11yTrProps,
    getTableProps: function getTableProps() {
      return getA11yTableProps;
    },
    NoDataComponent: renderNull,
    expanderDefaults: expanderDefaults,
    TrGroupComponent: AnimatedTrGroupComponent,
    TrComponent: AnimationResistantTrComponent,
    defaultSorted: defaultConfig.sorted,
    pageSize: pageSize,
    onPageChange: handlePageChange,
    onSortedChange: handleSortedChange
  }, modeProps, {
    manual: isSortedOnServer || isControlledMode
  })));
};
DataTable.propTypes = dataTablePropTypes;
DataTable.defaultProps = {
  showSearch: true,
  showPagination: true,
  defaultConfig: {
    filterValue: '',
    page: 0,
    pageSize: 10
  },
  onColumnFilter: defaultColumnFilter,
  pageSizeOptions: [10, 25, 50],
  expandable: true,
  multipleRowsExpandable: true,
  headerMultiline: false,
  selectionType: 'none',
  columnsConfigurable: true,
  noDataText: messages.noDataText,
  loadingText: messages.loadingText,
  localSorting: false,
  onGetRowId: function onGetRowId(row, index) {
    return index;
  },
  tableLabel: messages.tableLabel,
  filterPlaceholder: messages.searchPlaceholder
};
function normalize(value) {
  if (value === null || value === undefined) {
    return '';
  }
  return value;
}
AnimatedTrGroupComponent.__docgenInfo = {
  componentName: "AnimatedTrGroupComponent",
  packageName: "@jutro/datatable",
  description: "",
  displayName: "AnimatedTrGroupComponent",
  methods: [],
  actualName: "AnimatedTrGroupComponent"
};
AnimationResistantTrComponent.__docgenInfo = {
  componentName: "AnimationResistantTrComponent",
  packageName: "@jutro/datatable",
  description: "",
  displayName: "AnimationResistantTrComponent",
  methods: [],
  actualName: "AnimationResistantTrComponent"
};
splitHeaderText.__docgenInfo = {
  componentName: "splitHeaderText",
  packageName: "@jutro/datatable",
  description: "",
  displayName: "splitHeaderText",
  methods: [],
  actualName: "splitHeaderText"
};
DataTable.__docgenInfo = {
  componentName: "DataTable",
  packageName: "@jutro/datatable",
  description: "Component for displaying tabular data",
  displayName: "DataTable",
  methods: [],
  actualName: "DataTable",
  metadataType: "container",
  props: {
    id: {
      type: {
        name: "string"
      },
      required: true,
      description: "Used to identify the component"
    },
    showSearch: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Defines whether search bar should be shown",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    showPagination: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Defines whether pagination should be shown or not",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    config: {
      type: {
        name: "custom",
        raw: "dataTableConfigShape"
      },
      required: false,
      description: "Used to set data table config. Use it together with onConfigChange to control data table from outside.\nIt includes sorting method, filtering value, page, page size, edited row and columns sorting"
    },
    defaultConfig: {
      type: {
        name: "custom",
        raw: "dataTableConfigShape"
      },
      required: false,
      description: "The configuration applied only on component initialization.\nIt includes sorting method, filtering value, page, page size, edited row and columns sorting",
      defaultValue: {
        value: "{\n    filterValue: '',\n    page: 0,\n    pageSize: 10,\n}",
        computed: false
      }
    },
    onConfigChange: {
      type: {
        name: "func"
      },
      required: false,
      description: "Function to call after config value changes. New config value is passed as argument. It includes sorting method, filtering value, page, page size and columns visibility"
    },
    pageSizeOptions: {
      type: {
        name: "arrayOf",
        value: {
          name: "number"
        }
      },
      required: false,
      description: "List of page size options",
      defaultValue: {
        value: "[10, 25, 50]",
        computed: false
      }
    },
    data: {
      type: {
        name: "arrayOf",
        value: {
          name: "object"
        }
      },
      required: false,
      description: "Cells data"
    },
    onFilter: {
      type: {
        name: "func"
      },
      required: false,
      description: "Predicate function for searching data"
    },
    onColumnFilter: {
      type: {
        name: "func"
      },
      required: false,
      description: "Predicate function for searching data per column",
      defaultValue: {
        value: "defaultColumnFilter",
        computed: true
      }
    },
    filterPlaceholder: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Placeholder text for search input",
      defaultValue: {
        value: "messages.searchPlaceholder",
        computed: true
      }
    },
    children: {
      type: {
        name: "node"
      },
      required: true,
      description: "Column of any type (e.g. DisplayColumn)"
    },
    expandable: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Possibility to make rows expandable",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    multipleRowsExpandable: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Multiple rows can be expanded at the same time",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    renderExpanderContent: {
      type: {
        name: "func"
      },
      required: false,
      description: "Content of the expandable rows"
    },
    headerMultiline: {
      type: {
        name: "bool"
      },
      required: false,
      description: "If set to true header can be on 2 lines",
      defaultValue: {
        value: "false",
        computed: false
      }
    },
    onRowClick: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback for row click"
    },
    expandOnRowClick: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Row will expand on click"
    },
    selectOnRowClick: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Row will be selected on click"
    },
    selectionType: {
      type: {
        name: "enum",
        value: [{
          value: "'none'",
          computed: false
        }, {
          value: "'single'",
          computed: false
        }, {
          value: "'multi'",
          computed: false
        }]
      },
      required: false,
      description: "Configures row selection capability (none, single row, multi row)",
      defaultValue: {
        value: "'none'",
        computed: false
      }
    },
    selectedRows: {
      type: {
        name: "arrayOf",
        value: {
          name: "custom",
          raw: "rowIdShape"
        }
      },
      required: false,
      description: "Currently selected rows (passing value for this prop makes component fully controlled)"
    },
    selectionActions: {
      type: {
        name: "arrayOf",
        value: {
          name: "shape",
          value: {
            icon: {
              name: "string",
              required: true
            },
            label: {
              name: "string",
              required: true
            },
            callback: {
              name: "func",
              required: true
            }
          }
        }
      },
      required: false,
      description: "List of actions available for selection"
    },
    onSelectionChange: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback to be invoked when selection changed"
    },
    columnsConfigurable: {
      type: {
        name: "bool"
      },
      required: false,
      description: "If set to false, end user will not have a possibility to customize visibility of columns",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    loadingText: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Text to show while data is loading, by default - 'Loading..'",
      defaultValue: {
        value: "messages.loadingText",
        computed: true
      }
    },
    noDataText: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Text message, when no data present to be shown",
      defaultValue: {
        value: "messages.noDataText",
        computed: true
      }
    },
    localSorting: {
      type: {
        name: "bool"
      },
      required: false,
      description: "If set to true, sorting is happening locally after data is fetched\nOnly for async mode",
      defaultValue: {
        value: "false",
        computed: false
      }
    },
    phone: {
      type: {
        name: "object"
      },
      required: false,
      description: "Include any DataTable property to use at 'phone' breakpoint"
    },
    phoneWide: {
      type: {
        name: "object"
      },
      required: false,
      description: "Include any DataTable property to use 'phoneWide' and 'phone' breakpoint"
    },
    tablet: {
      type: {
        name: "object"
      },
      required: false,
      description: "Include any DataTable property to use at 'tablet', 'phoneWide' and 'phone' breakpoint"
    },
    onSaveRow: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback (row, rowId) to be invoked when row is saved"
    },
    onEditCancel: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback (row, rowId) to be invoked when row edit is canceled"
    },
    onEditStart: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback (row, rowId) to be invoked when row edit is started"
    },
    path: {
      type: {
        name: "string"
      },
      required: false,
      description: "The full path of view model, it also acts as an accessor for datatable's data"
    },
    onFetchData: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback to be invoked when new data has to be fetched in async mode,\nwith one argument of the current state of config object '{ filterValue, sorted, pageSize, page }'.\nShould return a promise of an object '{ rows, numberOfRows }', in which 'rows' is the filtered data to be presented for the current page,\n'numberOfRows' is the total length of whole data.\nIt takes precedence over `data` and `numberOfRows` sync props"
    },
    onGetRowId: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback (row) that returns unique id for the row.\nThe id should not change after editing the row.\nBy default index from data is used, but it does not work correctly when filtering.",
      defaultValue: {
        value: "(row, index) => index",
        computed: false
      }
    },
    rowIdPath: {
      type: {
        name: "string"
      },
      required: false,
      description: "Name of row object property containing the row id. Takes precedence over onGetRowId prop."
    },
    tableLabel: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Data table aria label",
      defaultValue: {
        value: "messages.tableLabel",
        computed: true
      }
    },
    numberOfRows: {
      type: {
        name: "number"
      },
      required: false,
      description: "Number of available rows"
    }
  }
};